import React from "react";

/* Estados de una operación de proveedor → color + etiqueta visual. */
export const PA_STATUS_META = {
  PROMO_DETECTED: { dot: "bg-emerald-400", cls: "bg-emerald-500/15 text-emerald-200 border-emerald-400/40", label: "PROMOCIÓN · RECARGA MANUAL" },
  PROMO_CHECK_UNKNOWN: { dot: "bg-yellow-400", cls: "bg-yellow-500/15 text-yellow-200 border-yellow-400/40", label: "PROMO SIN VERIFICAR" },
  NOT_ELIGIBLE: { dot: "bg-zinc-500", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40", label: "MANUAL · NO ELEGIBLE" },
  READY_FOR_PROVIDER: { dot: "bg-amber-400", cls: "bg-amber-500/15 text-amber-200 border-amber-400/40", label: "LISTA PARA PROVEEDOR" },
  EXECUTING: { dot: "bg-sky-400", cls: "bg-sky-500/15 text-sky-200 border-sky-400/40", label: "EJECUTANDO" },
  RECONCILING: { dot: "bg-orange-400", cls: "bg-orange-500/15 text-orange-200 border-orange-400/40", label: "CONCILIANDO" },
  CONFIRMED: { dot: "bg-emerald-400", cls: "bg-emerald-500/15 text-emerald-200 border-emerald-400/40", label: "CONFIRMADA" },
  SIMULATED: { dot: "bg-fuchsia-400", cls: "bg-fuchsia-500/15 text-fuchsia-200 border-fuchsia-400/40", label: "SIMULADA (DRY-RUN)" },
  UNKNOWN: { dot: "bg-orange-500", cls: "bg-orange-500/15 text-orange-200 border-orange-400/40", label: "INDETERMINADA" },
  MANUAL_REVIEW: { dot: "bg-violet-400", cls: "bg-violet-500/15 text-violet-200 border-violet-400/40", label: "REVISIÓN HUMANA" },
  FAILED: { dot: "bg-red-500", cls: "bg-red-500/15 text-red-200 border-red-400/40", label: "FALLIDA" },
  BLOCKED: { dot: "bg-zinc-400", cls: "bg-zinc-500/15 text-zinc-200 border-zinc-400/40", label: "BLOQUEADA" },
};

export const PA_TIMELINE = [
  "CREATED", "READY_FOR_PROVIDER", "EXECUTING", "SUBMITTED", "RECONCILING", "CONFIRMED",
];

export const paStatusMeta = (status, { autoReconcile } = {}) => {
  // El proveedor suele tardar más que el timeout: mientras la conciliación automática
  // sigue en marcha, la recarga está "procesando", no indeterminada.
  if (status === "UNKNOWN" && autoReconcile && !autoReconcile.finished) {
    return { dot: "bg-sky-400", cls: "bg-sky-500/15 text-sky-200 border-sky-400/40",
      label: "PROCESANDO · CONFIRMANDO" };
  }
  return PA_STATUS_META[status] || { dot: "bg-zinc-500", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40", label: status || "—" };
};

export const PaStatusBadge = ({ status, autoReconcile }) => {
  const meta = paStatusMeta(status, { autoReconcile });
  return (
    <span
      data-testid={`pa-status-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[10px] font-mono font-bold uppercase tracking-widest ${meta.cls}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} aria-hidden="true" />
      {meta.label}
    </span>
  );
};

export const paMoney = (value) =>
  value == null ? "—" : `$${Number(value).toFixed(2)}`;

export const paDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-VE", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
};
